// Code for creating a curve from a set of points

import * as THREE from 'three';

function get_curve(list_of_3d_vectors) {
  // TODO: add some hyperparameters to this function
  const curve = new THREE.CatmullRomCurve3(
    list_of_3d_vectors,
    false,
    // 'centripetal'
    'chordal',
  );
  return curve;
}

export function get_curve_object_from_cameras(cameras) {
  // interpolate positions, lookat directions, and ups
  // similar to
  // https://github.com/google-research/multinerf/blob/1c8b1c552133cdb2de1c1f3c871b2813f6662265/internal/camera_utils.py#L281

  const positions = [];
  const lookats = [];
  const ups = [];

  for (let i = 0; i < cameras.length; i += 1) {
    const camera = cameras[i];

    const up = new THREE.Vector3(0, 1, 0); // y is up in local space
    const lookat = new THREE.Vector3(0, 0, 1); // z is forward in local space

    up.applyQuaternion(camera.quaternion);
    lookat.applyQuaternion(camera.quaternion);

    positions.push(camera.position);
    ups.push(up);
    lookats.push(lookat);
  }

  let curve_positions = null;
  let curve_lookats = null;
  let curve_ups = null;

  curve_positions = get_curve(positions);
  curve_lookats = get_curve(lookats);
  curve_ups = get_curve(ups);

  const curve_object = {
    curve_positions,
    curve_lookats,
    curve_ups,
  };

  return curve_object;
}

export function get_transform_matrix(position, lookat, up) {
  // normalize the vectors
  lookat.normalize();
  up.normalize();

  // create a copy of the vector up
  const up_copy = up.clone();
  const cross = up_copy.cross(lookat);
  cross.normalize();

  // create the camera transform matrix
  const mat = new THREE.Matrix4();
  mat.set(
    cross.x,
    up.x,
    lookat.x,
    position.x,
    cross.y,
    up.y,
    lookat.y,
    position.y,
    cross.z,
    up.z,
    lookat.z,
    position.z,
    0,
    0,
    0,
    1,
  );
  return mat;
}
